import { Request } from '@group-devs/yfp7-global-modules'
import { Container, Row, Col, Image } from 'react-bootstrap';
import Link from 'next/link';
import { FaRegPlayCircle } from "react-icons/fa";

const request = new Request(process.env.apiDomain)

function IndexHeader (props) {
    
    const { data: profile } = request.account.swrAccountProfile(props.site.site.accountId)
    const { data: branding  } = request.account.swrBranding(props.site.site.accountId, profile ? profile.user.id : profile)

    return (
        <>
        <div className="section-discover-heading">
            <Container>
                <Row>
                    <Col md={6}>
                        {/*<h3 className="d-md-block d-none"><strong>{profile ? profile.name : null}</strong></h3>
                        <p className="d-md-block d-none">{branding ? branding.branding_handle : null}</p>
                        <hr className="d-md-block d-none"/>*/}
                        <h4>Explore natural ways to feel healthier, <br className="d-xl-block d-none"/>
                            more energetic and more focused.</h4>
                        <p><Link href="/explore/tour" passHref><a className="btn btn-watch-videos"><FaRegPlayCircle size={34} className="mr-3"/>Click to Watch Videos</a></Link></p>
                        <p className="hub-login-link"><Link href={props.site.auth.isAuthenticated ? '/home' : '/login'} passHref><a> {props.site.auth.isAuthenticated ? 'Enter Dashboard' : 'Or Login Here'}</a></Link></p>
                    </Col>
                </Row>
                <Image src="../images/discover/img-couple-shaklee-products01.png" alt="Wellness Guide" className="img-fluid d-block mx-auto"/>
            </Container>
        </div>
        <style jsx global>{`

                .section-discover-heading {
                    font-size: 18px;
                    line-height: 30px;
                    color: #1b1b1b;
                    background: #efefef;
                }

                .section-discover-heading .container {
                    position: relative;
                    padding-top: 100px;
                    padding-bottom: 120px;
                }

                .section-discover-heading h3 {
                    padding-top: 30px;
                    margin-bottom: 0px;
                    color: rgba(67,166,73,1.00);
                }

                .section-discover-heading hr {
                    width: 84px;
                    margin: 0px 0px 30px;
                    border-bottom: 3px solid rgba(67,166,73,1.00);
                }

                .section-discover-heading h4 {
                    font-size: 26px;
                    line-height: 40px;
                    margin-bottom: 30px;
                    font-weight: 400;
                }

                .section-discover-heading p {
                    margin-bottom: 10px;
                }

                .section-discover-heading .btn-watch-videos {
                    font-size: 20px;
                    padding: 9px 40px 6px;
                    text-transform: uppercase;
                    font-weight: 700;
                    border-radius: 50px;
                    background: rgba(67,166,73,1.00);
                    color: #fff;
                }

                .section-discover-heading .btn-watch-videos:hover {
                    background: rgba(67,166,73,0.7);
                }

                .section-discover-heading .btn-watch-videos .fa-stack-1x {
                    left: 1px;
                    font-size: 15px;
                }

                .section-discover-heading .hub-login-link {
                    max-width: 395px;
                    text-align: center;
                    margin-top: 20px;
                    font-size: 16px;
                }

                .section-discover-heading .hub-login-link a {
                    color: rgba(67,166,73,1.00);
                }

                .section-discover-heading img {
                    position: absolute;
                    width: 45%;
                    right: 0;
                    bottom: 0;
                }

                @media (min-width: 992px) and (max-width: 1199.98px) {

                    .section-discover-heading .container {
                        padding-top: 70px;
                        padding-bottom: 70px;
                    }

                }

                @media (min-width: 768px) and (max-width: 991.98px) {

                    .section-discover-heading .container {
                        padding-top: 70px;
                        padding-bottom: 70px;
                    }

                    .section-discover-heading h4 {
                        font-size: 22px;
                        line-height: 30px;
                    }

                    .section-discover-heading .btn-watch-videos {
                        font-size: 14px;
                    }

                }

                @media (max-width: 767.98px) {

                    .section-discover-heading .container {
                        text-align: center;
                        padding-top: 40px;
                        padding-bottom: 0;
                    }

                    .section-discover-heading hr {
                        margin: 0px auto 30px;
                    }

                    .section-discover-heading h4 {
                        font-size: 18px;
                        line-height: 28px;
                    }

                    .section-discover-heading .btn-watch-videos {
                        font-size: 14px;
                        padding: 5px 15px;
                    }

                    .section-discover-heading .btn-watch-videos svg {
                        width: 26px;
                    }

                    .section-discover-heading img {
                        position: relative;
                        width: 100%;
                        max-width: 400px;
                    }

                    .section-discover-heading .hub-login-link {
                        text-decoration: underline;
                        max-width: none;
                    }

                }

            `}</style>
        </>
    );
}

export default IndexHeader;